import React, {Component} from 'react';
import './Avatar.css';

class Avatar extends Component {
	render() {
		const {imagePath, approved, title} = this.props;
		return (
			<div
				title={title}
				className={`Avatar ${approved ? 'approved' : ''}`}
				style={{
					backgroundImage: imagePath ? `url(${imagePath})` : undefined,
					backgroundColor: imagePath ? undefined : '#ddd'
				}}
			>
				{imagePath ? undefined : <span>?</span>}
			</div>
		);
	}
}

export default Avatar;


// WEBPACK FOOTER //
// ./src/widgets/Avatar.js